module.exports = __webpack_public_path__ + "img/54.04ea10b9.svg";